import * as React from "react";

export const CustomToast = (title: string, message: string) => (
  <div>
    {title}
    <br />
    {message}
  </div>
);
